
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gVUv5yq6gUnHdkTtMqtGg7uPUJ84eAnWhYaLl7JvPAtAMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexTImcnvL6J0fu62iGfkH_1vwxd7oako45Xed_45ZCfttnwMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchLeT0gkK2VPko8nRIcV8cHXeETIHXOI231R3OySHAKwUMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexrURckwSpM8g6p3rD_45lDV4XavY8EbvaCSsL9ROFUDW8AMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93yQYoIabHDkqJPI_nPr4yFPyW6bdWtUUC9A9MdKt7YeAMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexqQu6rj5BdH3m8QkMMruXk583s5aBLD00XNHstECvCrEMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93jffH6758eRk9ShyEtG15NZTP4sULct_45UbJaUYU8_iSsMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexO5LZH1vEJAhbKVNRBdJowiWxUFPT9I6xW2j1EEgoutMMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93BYrW8FRd9esNlx5qS_SQKBu_WiE41HNO8DtLHFTTaPAMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexI5lcC7cCLD281YRMpaSWToaiWOJmIfDrZDQzTsVfvkYMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index9AhqNvAiQql8LefFxfUIa4B_IdDoqNZbRCc2vlcvFMAMeta } from "/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexqQu6rj5BdH3m8QkMMruXk583s5aBLD00XNHstECvCrEMeta || {},
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexO5LZH1vEJAhbKVNRBdJowiWxUFPT9I6xW2j1EEgoutMMeta || {},
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexI5lcC7cCLD281YRMpaSWToaiWOJmIfDrZDQzTsVfvkYMeta || {},
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index9AhqNvAiQql8LefFxfUIa4B_IdDoqNZbRCc2vlcvFMAMeta || {},
    component: () => import("/codebuild/output/src3809630123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]